import { useGLTF } from "@react-three/drei";
import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { ANIMATION_SPEED, OBSTACLE_SPEED_MULTIPLIER } from '../constants';

export function Building({ position, isMoving }) {
    const meshRef = useRef();
    const { scene } = useGLTF('/building.glb');
    
    // Clone the scene to avoid sharing the same geometry between instances
    const clonedScene = scene.clone();

    useFrame((state, delta) => {
        if (isMoving && meshRef.current) {
            meshRef.current.position.z -= ANIMATION_SPEED * OBSTACLE_SPEED_MULTIPLIER * delta;
        }
    });

    return (
        <primitive
            ref={meshRef}
            object={clonedScene}
            position={position}
            scale={[1, 1, 1]}
        />
    );
}

// Preload the model
useGLTF.preload('/building.glb'); 